import React from 'react'

export default function Lifetime({
  stats,
  clicks,
}: {
  stats: any
  clicks: any
}) {
  return (
    <div className="mb-6 grid grid-cols-4 gap-4">
      <div className="text-center">
        <p>
          <span className="mr-2 inline-block h-[10px] w-[10px] rounded-full bg-[#00D775]" />
          Visits
        </p>
        <p className="text-2xl">{stats?.visits?.value || 'N/A'}</p>
      </div>

      <div className="text-center">
        <p>
          <span className="mr-2 inline-block h-[10px] w-[10px] rounded-full bg-[#7C41FF]" />
          Unique visitor
        </p>
        <p className="text-2xl">{stats?.visitors?.value || 'N/A'}</p>
      </div>

      <div className="text-center">
        <p>
          <span className="mr-2 inline-block h-[10px] w-[10px] rounded-full bg-[#E413FF]" />
          Views
        </p>
        <p className="text-2xl">{stats?.pageviews?.value || 'N/A'}</p>
      </div>

      <div className="text-center">
        <p>
          <span className="mr-2 inline-block h-[10px] w-[10px] rounded-full bg-[#FF7913]" />
          Clicks
        </p>
        <p className="text-2xl">{clicks || 'N/A'}</p>
      </div>
    </div>
  )
}
